import { TableHeaderConfig } from '../../../components/_EOS/Table'

export const priorityTableHeaderConfigs: TableHeaderConfig[] = [
  { field: 'typePriorityId', title: 'ID' },
  {
    field: 'name',
    title: 'Prioridad'
  },
  {
    field: 'value',
    title: 'Valor'
  }
]
